// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"

const $ = window.$;
const _ = window._;
const Backbone = window.Backbone;
const PptxGenJS = window.PptxGenJS;
const JSZip = window.JSZip;

export {
    $,
    _,
    Backbone,
    PptxGenJS,
    JSZip
};
